var map = {
	"./Base": 735,
	"./Base/": 735,
	"./Base/index": 735,
	"./Base/index.js": 735,
	"./Base/style": 175,
	"./Base/style.js": 175,
	"./Clutch": 425,
	"./Clutch/": 425,
	"./Clutch/index": 425,
	"./Clutch/index.js": 425,
	"./Clutch/renderComponent": 1670,
	"./Clutch/renderComponent.js": 1670,
	"./Clutch/style": 1309,
	"./Clutch/style.js": 1309,
	"./NewUi": 1027,
	"./NewUi/": 1027,
	"./NewUi/index": 1027,
	"./NewUi/index.js": 1027,
	"./NewUi/style": 1310,
	"./NewUi/style.js": 1310,
	"./OldUi": 1028,
	"./OldUi/": 1028,
	"./OldUi/index": 1028,
	"./OldUi/index.js": 1028,
	"./OldUi/renderComponent": 1671,
	"./OldUi/renderComponent.js": 1671,
	"./OldUi/style": 1311,
	"./OldUi/style.js": 1311,
	"./SpireonNew": 1029,
	"./SpireonNew/": 1029,
	"./SpireonNew/index": 1029,
	"./SpireonNew/index.js": 1029,
	"./SpireonNew/renderComponent": 1672,
	"./SpireonNew/renderComponent.js": 1672,
	"./SpireonNew/style": 1312,
	"./SpireonNew/style.js": 1312,
	"./SpireonOld": 1030,
	"./SpireonOld/": 1030,
	"./SpireonOld/index": 1030,
	"./SpireonOld/index.js": 1030,
	"./SpireonOld/renderComponent": 1673,
	"./SpireonOld/renderComponent.js": 1673,
	"./SpireonOld/style": 1313,
	"./SpireonOld/style.js": 1313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80;